export default __webpack_public_path__ + "static/media/out-bck-bw-faded.b57a7628.jpg";